export default __webpack_public_path__ + "static/media/8820.6b612b2c.svg";